module.exports = __webpack_public_path__ + "assets/img/bg8.8fb1598b.gif";